enum MyFirstGameStepNames {
  default = '',
  letsBegin = 'lets-begin',
  holeAndCommunityCards = 'hole-and-community-cards',
  letsGoFaceUp = 'lets-go-face-up',
  faceUpNote = 'face-up-note',
  rounds = 'rounds',
  roles = 'roles',
  forcedBets = 'forced-bets',
  smallBlind = 'small-blind',
  bigBlind = 'big-blind',
  handRankingsNote = 'hand-rankings-note',
  preFlopRoundNote = 'pre-flop-round-note',
  preFlopStrategy = 'pre-flop-strategy',
  petraRaises1 = 'petra-raises-300-1',
  leslieCalls1 = 'leslie-calls-1',
  userTurnCall1 = 'user-turn-call',
  firstRoundFinished = 'first-round-finished',
  claudiaFolds = 'claudia-folds',
  estherCalls2 = 'esther-calls-2',
  theFlop = 'the-flop',
  estherPreCheck = 'esther-pre-check',
  estherChecks2 = 'esther-checks-2',
  petraBets2 = 'petra-bets-2',
  userTurnCall2 = 'user-turn-call-2',
  leslieFolds = 'leslie-folds',
  estherTurnPreFold = 'esther-turn-pre-fold',
  estherFolds = 'esther-folds',
  secondRoundFinished = 'second-round-finished',
  theTurn = 'the-turn',
  beforePetraBets3 = 'before-petra-bets-3',
  petraBets3 = 'petra-bets-3',
  userTurnCall3 = 'user-turn-call-3',
  thirdRoundFinished = 'third-round-finished',
  theRiver = 'the-river',
  petraBets4 = 'petra-bets-4',
  userTurnCall4 = 'user-turn-call-4',
  fourthRoundFinished = 'fourth-round-finished',
  theShowdown = 'the-showdown',
  winnerNote = 'winner-note',
  beforeWinnerNote = 'before-winner-note',
  endCard = 'end-card'
}

export default MyFirstGameStepNames
